export default __webpack_public_path__ + "static/media/5.8afae5e1.jpeg";